export const wizardFormKeys = {
  all: ['wizard-form'],
  detail: (id) => [...wizardFormKeys.all, 'detail', parseInt(id)],
  pending: () => [...wizardFormKeys.all, 'pending'],
  payment: (id) => [...wizardFormKeys.all, 'payment', parseInt(id)],
  wizardItems: (ids = []) => [
    ...wizardFormKeys.all,
    'wizard-items',
    ...[...ids].map((id) => parseInt(id, 10)).sort((a, b) => a - b),
  ],
};
